export default __webpack_public_path__ + "static/media/bx-time-five.ac07d53c.svg";